<template>
<p> While needs may vary on a performance-by-performance basis, our standard sound plot can be viewed here </p>
</template>
